<ng-container *ngIf="projects?.length">
	<div
		class="flex gap-3 bg-white border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
		role="button"
		(click)="toggleDropdown()"
	>
		<svg class="stroke-icon mx-2">
			<use [attr.xlink:href]="'assets/svg/icon-sprite.svg#stroke-project'"></use>
		</svg>

		<span class="font-medium text-gray-800 me-1">{{ selectedProject?.name }}</span>
		<i
			*ngIf="this.projects?.length > 1"
			class="me-3 fa fa-chevron-down text-gray-500 text-sm transition-transform"
			[ngClass]="{ 'rotate-180': isDropdownOpen }"
		></i>
	</div>

	<ul class="profile-dropdown" [class.show]="isDropdownOpen">
		<ng-container *ngFor="let project of this.projects">
			<li *ngIf="selectedProject?._id !== project._id">
				<a role="button" (click)="changeProject(project._id)">
					<app-feather-icons [icon]="'server'"></app-feather-icons>
					<span>{{ project?.name }}</span>
				</a>
			</li>
		</ng-container>
	</ul>
</ng-container>
